import React from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';

type Props = {
	autoAssignMode: 'unassigned_only' | 'unassigned_received' | 'assigned_without_received';
	onAutoAssignModeChange: (mode: 'unassigned_only' | 'unassigned_received' | 'assigned_without_received') => void;
	onAutoAssign: () => void;
	busy: boolean;
};

const Stage3AssignmentTab = ({ autoAssignMode, onAutoAssignModeChange, onAutoAssign, busy }: Props) => {
	return (
		<>
			<Typography variant='subtitle1'>Automatyczny przydział prac komisjom</Typography>
			<Typography
				variant='caption'
				sx={{ mb: 2, display: 'block' }}
			>
				Przydziela prace uczniów do komisji z uwzględnieniem kolizji okręgów i równomiernego obciążenia.
			</Typography>
			<FormControl
				fullWidth
				size='small'
				sx={{ mb: 1 }}
			>
				<InputLabel id='auto-assign-mode-label'>Tryb auto-przydziału</InputLabel>
				<Select
					labelId='auto-assign-mode-label'
					label='Tryb auto-przydziału'
					value={autoAssignMode}
					onChange={(e) =>
						onAutoAssignModeChange(
							e.target.value as 'unassigned_only' | 'unassigned_received' | 'assigned_without_received',
						)
					}
				>
					<MenuItem value='unassigned_only'>Tylko nieprzypisane</MenuItem>
					<MenuItem value='unassigned_received'>Nieprzydzielone z otrzymanymi pracami</MenuItem>
					<MenuItem value='assigned_without_received'>Przypisane, ale bez otrzymanych prac</MenuItem>
				</Select>
			</FormControl>
			<Box sx={{ mt: 1 }}>
				<Button
					variant='contained'
					onClick={onAutoAssign}
					disabled={busy}
				>
					Auto-przydział
				</Button>
			</Box>
		</>
	);
};

export default Stage3AssignmentTab;
